import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';
import { getBankAccounts, clearBankAccounts } from '../../../../actions';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';

const BankAccountSelect = ({
  dispatchGetBankAccounts,
  dispatchClearBankAccounts,
  bankAccounts,
  isLoading,
  isMulti,
  input,
  meta,
  ...rest
}) => {
  useLayoutEffect(() => {
    const query = ['active:true'];

    dispatchGetBankAccounts({ ...DEFAULT_QUERY_GET_ALL, query });

    return () => {
      dispatchClearBankAccounts();
    };
  }, []);

  return (
    <Select
      options={bankAccounts}
      isLoading={isLoading}
      isMulti={isMulti}
      input={input}
      meta={meta}
      {...rest}
    />
  );
};

BankAccountSelect.propTypes = {
  dispatchGetBankAccounts: PropTypes.func.isRequired,
  dispatchClearBankAccounts: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  bankAccounts: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
      bankId: PropTypes.number,
    }),
  ),
  meta: metaPropTypes,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

BankAccountSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  isLoading: false,
  isMulti: false,
  bankAccounts: [],
  isDisabled: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  bankAccounts: AccountingUnit.BankAccount.getIn([
    'all',
    'content',
    'content',
  ]).map((bankAccount) => {
    const currencyMap = {
      PEN: 'Soles',
      USD: 'Dólares',
      EUR: 'Euros',
    };

    const currencyName =
      currencyMap[bankAccount.currency] || bankAccount.currency;

    const receiptLabel = bankAccount.receipt ? ` - ${bankAccount.receipt}` : '';

    return {
      value: bankAccount.id,
      label: `${bankAccount.bank.name} - ${bankAccount.accountNumber} (${currencyName}) ${receiptLabel} - CCI: ${bankAccount.interbankNumber}`,
      bankId: bankAccount.bank.id,
    };
  }),
  isLoading: AccountingUnit.BankAccount.getIn(['all', 'loading']),
});

const mapDispatchToprops = {
  dispatchGetBankAccounts: getBankAccounts,
  dispatchClearBankAccounts: clearBankAccounts,
};

export default connect(mapStateToProps, mapDispatchToprops)(BankAccountSelect);
